'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleScrollPercentageChange = undefined;

var _getLatestWidgetData = require('../../widget-data/selectors/getLatestWidgetData');

var _executeClientTrigger = require('../../client-triggers/actions/executeClientTrigger');

var _getTargetScrollPercentage = require('../operators/getTargetScrollPercentage');

var handleScrollPercentageChange = exports.handleScrollPercentageChange = function handleScrollPercentageChange(_ref) {
  var scrollPercentage = _ref.scrollPercentage;
  return function (dispatch, getState) {
    var widgetData = (0, _getLatestWidgetData.getLatestWidgetData)(getState());

    if (scrollPercentage >= (0, _getTargetScrollPercentage.getTargetScrollPercentage)(widgetData)) {
      dispatch((0, _executeClientTrigger.executeClientTrigger)());
    }
  };
};